import { render, staticRenderFns } from "./time.vue?vue&type=template&id=cf5cb61a&scoped=true&"
import script from "./time.vue?vue&type=script&lang=js&"
export * from "./time.vue?vue&type=script&lang=js&"
import style0 from "./time.vue?vue&type=style&index=0&id=cf5cb61a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5cb61a",
  null
  
)

export default component.exports